import { ColDef, ColGroupDef } from "ag-grid-community";
import { StoreExtended } from "models/dbModels/stores/Store";
import { Badge } from "react-bootstrap";

export function getPreferredBrandsStoresConfig(preferredBrandsAtStores: number[]): (ColDef<StoreExtended> | ColGroupDef<StoreExtended>)[]| null {
    return [
        {
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 45,
            sortable: false,
            filter: false,
            suppressHeaderMenuButton: true,
        },
        {
            headerName: "Name",
            field: "name",
            flex: 1,
            minWidth: 250,
            initialSort: "asc"
        },
        {
            headerName: "Store Status",
            field: "connected",
            minWidth: 200,
            flex: 1,
            cellRendererSelector: (params) => {
                return {
                    component: 'baseCellRenderer',
                    params: {
                        children: <div>{params.data?.connected == true? (<Badge className="me-1 badge-outline-success">Online</Badge>) : (<Badge className="me-1 badge-outline-danger">Offline</Badge>)}</div>
                    }
                }
            }
        },
        {
            headerName: "Status",
            field: "status",
            minWidth: 200,
            flex: 3,
            cellRendererSelector: (params) => {
                return {
                    component: 'baseCellRenderer',
                    params: {
                        children: <div>{preferredBrandsAtStores.includes(params.data?.id as number) ? (<Badge className="me-1 badge-outline-success">Sent</Badge>) : (<Badge className="me-1 badge-outline-warning">Pending</Badge>)}</div>
                    }
                }
            }
        }
    ];
}